import { render, staticRenderFns } from "./About.vue?vue&type=template&id=546874de&"
import script from "./about.ts?vue&type=script&lang=ts&"
export * from "./about.ts?vue&type=script&lang=ts&"
import style0 from "./about.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports